export default __webpack_public_path__ + "static/media/big_head_-10.785522ec.webp";